import moment from "moment";

export function removeDuplicates(elements) {

    return elements.filter(function (el, index, arr) {
        return arr.indexOf(el) === index;
    })
}
export function objectToString(obj) {
    var str = '';
    for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
            str += p + '::' + obj[p] + '\n';
        }
    }
    return str;
}
export function getColorChart (id, type, alpha) {

    if (arguments[2] == undefined) {
        arguments[2] = 1;
    }


    if (type == "HEX") {
        return colorsHEX(id);
    } else {
        var temp = colorsRGB(id);
        console.log("rgba(" + temp[0] + "," + temp[1] + "," + temp[2] + "," + alpha + ")");
        return "rgba(" + temp[0] + "," + temp[1] + "," + temp[2] + "," + alpha + ")";
    }


}
export function getColorChartArray(len, type, alpha) {
    var arr = [];

    if (arguments[2] == undefined) {
        arguments[2] = 1;
    }

    if (type == "HEX") {
        for (var i = 0; i < len; i++) {



            arr.push(colorsHEX(i+2));

        }

    } else {
        for (var i = 0; i < len; i++) {
            var temp = colorsRGB(i + 2);

            arr.push("rgba("+temp[0]+","+temp[1]+","+temp[2]+","+alpha+")");
        }

    }


    //Shuffle(arr);

    return arr;
}
function Shuffle(o) {
    for (var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
};
var colorsHEX = function(index){
    var colors = [
        "#FFFFFF", //white
        "#000000", //black
        "#3366CC", //blue
        "#E87C1E", //orange
        "#93B63A", //green
        "#E6B817", //gold
        "#099E9C", //dark green
        "#CCCCCC", //lightgray
        "#09698D", //dark blue
        "#666666", //dark gray
        "#DD5454", //pink
        "#7698DD", //blue
        "#B7B7B7", //gray
        "#FFFFFF", //white
        "#000000", //black
        "#3366CC", //blue
        "#CCCCCC", //lightgray
        "#93B63A", //green
        "#E6B817", //gold
        "#E87C1E", //orange
        "#099E9C", //dark green
        "#09698D", //dark blue
        "#666666", //dark gray
        "#DD5454", //pink
        "#7698DD", //blue
        "#B7B7B7", //gray
        "#FF2200", //red
  ];
  
  if (index >= colors.length) {
    
    let ind = Math.floor(Math.random() * (colors.length));
    return colors[ind];
  }

    return colors[index];
}
let colorsRGB = function (index) {
  
  let colors = [
      [255, 255, 255], //white
      [0, 0, 0], //black
      [51, 102, 204], //blue
      [232, 124, 30], //orange
      [147, 182, 58], //green
      [230, 184, 23], //gold
      [9, 158, 156], //dark green
      [204, 204, 204], //lightgray
      [9, 105, 141], //dark blue
      [102, 102, 102], //dark gray
      [238, 168, 168], //pink
      [118, 152, 221], //blue
      [183, 183, 183], //gray
      [255, 255, 255], //white
      [0, 0, 0], //black
      [51, 102, 204], //blue
      [204, 204, 204], //lightgray
      [147, 182, 58], //green
      [230, 184, 23], //gold
      [232, 124, 30], //orange
      [9, 158, 156], //dark green
      [9, 105, 141], //dark blue
      [102, 102, 102], //dark gray
      [238, 168, 168], //pink
      [118, 152, 221], //blue
      [183, 183, 183], //gray
      [204, 0, 0], //red
  ];
  
  if (index >= colors.length) {
    
    let ind = Math.floor(Math.random() * (colors.length));
    return colors[ind];
  }

  return colors[index];
}
export function arrayToObject(array) {
    var obj = {};

    for (var i = 0, le = array.length; i < le; i++){

        obj[i]= array[i];
    }
    return obj;
}

export function getTo(type){

  

  if (type == "Part"){
    return "/PartManager/PartDetails";
  }else if (type == "Symbol"){
    return "/LibraryManager/LibraryDetails";
  }else if (type == "Footprint"){
    return "/LibraryManager/LibraryDetails";
  }else if (type == "Padstack"){
    return "/LibraryManager/LibraryDetails";
  }else if (type == "Pad"){
    return "/LibraryManager/LibraryDetails";
  }else if (type == "Project"){
    return "/Project/ProjectDetails";  
  }else{
    return "";
  }


}


export function getStatusColor(data){

  let variant = "";
  if (data == "active"){
    variant = "success";
  }else if (data == "obsolete"){
    variant = "danger";
  }else if (data == "pending"){
    variant = "primary";
  }else if (data == "withdrawn"){
    variant = "warning";
  }else if (data == "closed"){
    variant = "warning";
  } else if (data == "checkedout") {
    variant = "diff";
  } else if (data == "pushed") {
    variant = "info";
  }

  return variant;

}

export function dateToUTC(date){

  return new Date(date).toUTCString();
}

export function longDateToShort(date, time = true) {
  if (date == null) {
    return "";
  }
  if (date != "" || date != null) {
    if (time == true) {
     
      return moment.utc(date).local().format('YYYY-MM-DD HH:mm');
    } else {
      return moment.utc(date).local().format('YYYY-MM-DD');
    }
  } else {
    return "";
  }

}
export function IntegerToIntegerUTC(int) {
  return int;
  let out = 0;
  
 
  let utc = moment(int).utc().format('YYYY-MM-DD HH:mm:ss')
 
  out = new Date(utc).getTime()
    
  return out;
}

export function filenameToIcon(filename) {
  if (filename == null || filename == undefined) {
    return ""
  }
  let temp = filename.toLowerCase().split(".");
  let src = "/static/file.png"
  if (temp[temp.length - 1] == "dra"){
    src = "/static/dra.png"
  }
  if (temp[temp.length - 1] == "olb"){
    src = "/static/olb.png"
  }
  if (temp[temp.length - 1] == "pad"){
    src = "/static/pad.png"
  }
  if (temp[temp.length - 1] == "pdf"){
    src = "/static/pdf.png"
  }
  if (temp[temp.length - 1] == "dsn"){
    src = "/static/dsn.png"
  }
  if (temp[temp.length - 1] == "opj"){
    src = "/static/opj.png"
  }
  if (temp[temp.length - 1] == "txt"){
    src = "/static/txt.png"
  }
  if (temp[temp.length - 1] == "csv"){
    src = "/static/csv.png"
  }

  return src
}
export function escapeText(txt) {
  console.log(txt, typeof "txt")
  if (typeof txt == "string") {
    txt = txt.replace(/\&/g, '&#38;').replace(/\</g, '&#60;');
  }
  
  return txt;
}

export function compareObjects(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
}


// WEBPACK FOOTER //
// ./src/Tools/Tools.js